module.exports = __webpack_public_path__ + "img/orange.980f8d24.jpg";